import { Button, Typography, SxProps, Theme, ButtonProps } from "@mui/material";
import colorConfigs from "../../../configs/colorConfigs";
import { typo } from "../../../assets/fonts/font";

interface CustomButtonProps extends ButtonProps {
  buttonType: "primary" | "secondary";
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

const CustomButton = ({
  buttonType,
  children,
  sx,
  ...rest
}: CustomButtonProps) => {
  const defaultStyle: SxProps<Theme> = {
    backgroundColor: colorConfigs[buttonType],
    borderRadius: "50px",
    color: colorConfigs.secondary,
    textTransform: "none",
    "&:hover": {
      backgroundColor: colorConfigs[buttonType],
    },
    ...sx,
  };

  const content =
    typeof children === "string" ? (
      <Typography sx={{ ...typo.button }} component="span">
        {children}
      </Typography>
    ) : (
      children
    );

  return (
    <Button variant="contained" sx={defaultStyle} {...rest}>
      {content}
    </Button>
  );
};

export default CustomButton;
